// removed by extract-text-webpack-plugin
module.exports = {"warning":"warning__17W82"};


//////////////////
// WEBPACK FOOTER
// ./components/signup-flow/warning-message.sass
// module id = Eurl
// module chunks = 1